import type { BugStatus } from '../../types';
import type { StatusChipColor } from '../../theme';

export interface BugStatusMeta {
  label: string;
  color: StatusChipColor;
}

/** Nhãn + màu tiếng Việt cho từng trạng thái lỗi (bug). */
export const BUG_STATUS_META: Record<BugStatus, BugStatusMeta> = {
  OPEN: { label: 'Mới', color: 'error' },
  IN_PROGRESS: { label: 'Đang sửa', color: 'warning' },
  RESOLVED: { label: 'Đã sửa', color: 'success' },
  REJECTED: { label: 'Không phải lỗi', color: 'default' },
  VERIFIED: { label: 'Đã xác minh', color: 'info' },
  CLOSED: { label: 'Đóng', color: 'default' },
  REOPENED: { label: 'Mở lại', color: 'error' },
};

export const BUG_STATUS_OPTIONS: BugStatus[] = [
  'OPEN',
  'IN_PROGRESS',
  'RESOLVED',
  'REJECTED',
  'VERIFIED',
  'CLOSED',
  'REOPENED',
];

/**
 * Chip "Đang sửa lỗi" (Fixing) thay cho trạng thái tính năng khi tính năng còn bug mở.
 * Là trạng thái phái sinh (open_bug_count > 0), không lưu ở features.status.
 */
export const FEATURE_FIXING_META = { label: 'Đang sửa lỗi', color: 'error' as const };

/** Phải khớp OPEN_BUG_STATUSES ở apps/api/src/types.ts. */
export function isBugOpen(status: BugStatus): boolean {
  return status === 'OPEN' || status === 'IN_PROGRESS' || status === 'REOPENED';
}
